import Paragraph from '@/components/common/textElements/Paragraph.tsx'
import { cn } from '@/lib/utils.ts'
import { ChevronLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type PropsT = {
  parent: 'popover' | 'overlay'
  handleGoBack: () => void
  className?: string
}

export default function PropertyGoBack({ parent, handleGoBack, className }: PropsT) {
  const { t } = useTranslation()

  function onSelect() {
    handleGoBack()
  }

  return (
    <div className={cn('border-t py-2', className)}>
      <div className=" " />
      <div
        onClick={onSelect}
        className="cursor-pointer rounded-sm px-2 py-1.5 hover:bg-accent"
        data-cy="property-popover-property"
      >
        <div className="flex w-full items-center justify-between">
          <div className={cn(`flex items-center gap-2`, parent === 'overlay' && 'w-full')}>
            <ChevronLeft className={`size-4`} />
            <Paragraph variant={'default'} size="small">
              {t(`common.back`)}
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  )
}
